/* eslint-disable @typescript-eslint/no-explicit-any */
import { Client, fetchExchange, subscriptionExchange } from '@urql/core';
import { AuthConfig, authExchange } from '@urql/exchange-auth';
import { SubscribePayload, createClient as createWSClient } from 'graphql-ws';
import { getSdk } from './generated/urql.limited-access.universal';

export class UrqlGqlLimitedUniversal {
  private gqlClient: Client;
  private wsClient: ReturnType<typeof createWSClient>;

  private static userId = '';
  private static id = '';

  private kratosEndpoint: string;

  constructor(
    gqlEndpoint: string,
    wssEndpoint: string,
    kratosEndpoint: string
  ) {
    this.kratosEndpoint = kratosEndpoint;

    this.wsClient = createWSClient({
      url: wssEndpoint,
      connectionParams: () => {
        return {
          credentials: 'include',
          headers: {
            'x-hasura-user-id': UrqlGqlLimitedUniversal.userId,
          },
        };
      },
    });

    this.gqlClient = new Client({
      url: gqlEndpoint,
      requestPolicy: 'cache-and-network',
      exchanges: [
        authExchange(async (utils) => {
          UrqlGqlLimitedUniversal.userId = await this.getUserId();

          return {
            addAuthToOperation(operation) {
              if (!UrqlGqlLimitedUniversal.userId) return operation;
              return utils.appendHeaders(operation, {
                'x-hasura-user-id': UrqlGqlLimitedUniversal.userId,
              });
            },
          } as AuthConfig;
        }),
        fetchExchange,
        subscriptionExchange({
          forwardSubscription: (operation) => {
            return {
              subscribe: (sink) => {
                const dispose = this.wsClient.subscribe(
                  operation as SubscribePayload,
                  sink
                );
                return {
                  unsubscribe: dispose,
                };
              },
            };
          },
        }),
      ],
      fetchOptions: () => {
        const headers: HeadersInit = {};
        if (UrqlGqlLimitedUniversal.userId) {
          headers['x-hasura-user-id'] = UrqlGqlLimitedUniversal.userId;
        }

        return {
          credentials: 'include',
          headers: headers,
        };
      },
    });
  }

  private async getUserId(): Promise<string> {
    if (UrqlGqlLimitedUniversal.id) return UrqlGqlLimitedUniversal.id;
    try {
      const kratosResponse = await fetch(
        `${this.kratosEndpoint}/sessions/whoami`,
        {
          method: 'get',
          credentials: 'include',
          headers: {
            accept: 'application/json',
          },
        }
      );
      const sessionData = await kratosResponse.json();
      if (sessionData?.identity?.id) {
        UrqlGqlLimitedUniversal.id = sessionData?.identity?.id;
      }
    } catch (err) {
      console.warn('Issue with api-services whoami call! ', err);
    }
    return UrqlGqlLimitedUniversal.id;
  }

  public getGqlClientSdk() {
    return getSdk(this.gqlClient);
  }
}

export * from './generated/urql.limited-access.universal';
